import { tamanhoDiverge, tamanhoNoTexto } from '@domain/receipt'
import type { ReceiptItem } from '@domain/receipt'
import type { Product } from '@domain/product'

/**
 * O produto que a linha TEM: sugerido ou confirmado.
 *
 * A linha pulada ou que não existe pode ainda carregar o `productId` da
 * sugestão recusada — pular não o apaga —, e mostrar a foto ou o nome dele
 * seria afirmar o vínculo que a pessoa negou.
 */
export function produtoDaLinha(linha: ReceiptItem, produto: Product | null): Product | null {
  return linha.matchStatus === 'pending' || linha.matchStatus === 'confirmed' ? produto : null
}

/** O nome em destaque: o corrigido, o do produto, ou o lido. */
export function nomeDaLinha(linha: ReceiptItem, produto: Product | null): string {
  return linha.edited?.name ?? produtoDaLinha(linha, produto)?.name ?? linha.rawText
}

/** "310 ml", "1,5 l" — a medida como se lê, com vírgula decimal. */
function medida(t: { size: number | null; unit: string | null } | null): string {
  if (t === null || t.size === null || t.unit === null) return ''
  return `${String(t.size).replace('.', ',')} ${t.unit}`
}

/**
 * A frase das duas medidas, quando o cupom e o produto discordam — ou `null`.
 *
 * Mora aqui, e não na linha, porque é dita em dois lugares: na própria linha e
 * na folha de conferir (decisão 308). Duas cópias da mesma frase divergiriam no
 * primeiro ajuste de texto.
 */
export function fraseDaDivergencia(linha: ReceiptItem, produto: Product | null): string | null {
  if (produto === null || !tamanhoDiverge(linha.rawText, produto)) return null
  return `O cupom diz ${medida(tamanhoNoTexto(linha.rawText))}; o produto sugerido é de ${medida(produto)}.`
}

/**
 * O rastro de uma divergente aceita mesmo assim: "aceito · o cupom diz 310 ml".
 *
 * Antes o aviso sumia com o aceite, e não sobrava prova de que o papel dizia
 * outra coisa. Quieto, porque já não pede decisão — só não deixa esquecer.
 */
export function rastroDaDivergencia(linha: ReceiptItem, produto: Product | null): string | null {
  if (produto === null || !tamanhoDiverge(linha.rawText, produto)) return null
  return `aceito · o cupom diz ${medida(tamanhoNoTexto(linha.rawText))}`
}
